export const APP_NAME = "Ray Virtual Smile";